<lx-section-template [sectionIndex]="sectionIndex" [sectionTitle]="sectionTitle">
  <ng-container *ngTemplateOutlet="isAdultSchool() ? adultTemplate : juniorTemplate"></ng-container>
</lx-section-template>

<ng-template #adultTemplate>
  <lx-form-field
    label="Emergency Contact person - First name"
    i18n-label
    [small]="true"
    [isValid]="formData.contactPersonFirstName.isValid"
    [required]="formData.contactPersonFirstName.required"
    [errorMessage]="formData.contactPersonFirstName.errorMessage"
    [iconValidation]="true"
    data-qa="enrolment-emergency-contact-first-name"
  >
    <input
      pInputText
      type="text"
      lxFormDataInputValidity
      [formData]="formData.contactPersonFirstName"
      [(ngModel)]="formData.contactPersonFirstName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('contactPersonFirstName')"
      (focusout)="recalculateFormValidation('contactPersonFirstName')"
    />
  </lx-form-field>
  <lx-form-field
    label="Emergency Contact person - Last name"
    i18n-label
    [small]="true"
    [isValid]="formData.contactPersonLastName.isValid"
    [required]="formData.contactPersonLastName.required"
    [errorMessage]="formData.contactPersonLastName.errorMessage"
    [iconValidation]="true"
    data-qa="enrolment-emergency-contact-last-name"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.contactPersonLastName"
      [(ngModel)]="formData.contactPersonLastName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('contactPersonLastName')"
      (focusout)="recalculateFormValidation('contactPersonLastName')"
    />
  </lx-form-field>
  <lx-phone-number-field
    class="form-field__search-bar"
    i18n-label
    label="Emergency Contact person - mobile"
    [isValid]="formData.contactPersonPhone.isValid"
    [required]="formData.contactPersonPhone.required"
    [validationRequests]="validationRequests"
    (valueChange)="updatePhoneNumber($event, 'contactPersonPhone')"
    data-qa="enrolment-emergency-contact-mobile"
  ></lx-phone-number-field>
</ng-template>

<ng-template #juniorTemplate>
  <lx-form-field
    label="First name"
    i18n-label
    [small]="true"
    [isValid]="formData.legalRepresentativeFirstName.isValid"
    [required]="formData.legalRepresentativeFirstName.required"
    [errorMessage]="formData.legalRepresentativeFirstName.errorMessage"
    [iconValidation]="true"
    data-qa="enrolment-juniors-legal-representative-first-name"
  >
    <input
      pInputText
      type="text"
      lxFormDataInputValidity
      [formData]="formData.legalRepresentativeFirstName"
      [(ngModel)]="formData.legalRepresentativeFirstName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('legalRepresentativeFirstName')"
      (focusout)="recalculateFormValidation('legalRepresentativeFirstName')"
    />
  </lx-form-field>
  <lx-form-field
    label="Last name"
    i18n-label
    [small]="true"
    [isValid]="formData.legalRepresentativeLastName.isValid"
    [required]="formData.legalRepresentativeLastName.required"
    [errorMessage]="formData.legalRepresentativeLastName.errorMessage"
    [iconValidation]="true"
    data-qa="enrolment-juniors-legal-representative-last-name"
  >
    <input
      pInputText
      type="text"
      lxFormDataInputValidity
      [formData]="formData.legalRepresentativeLastName"
      [(ngModel)]="formData.legalRepresentativeLastName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('legalRepresentativeLastName')"
      (focusout)="recalculateFormValidation('legalRepresentativeLastName')"
    />
  </lx-form-field>
  <lx-form-field
    label="Email address"
    i18n-label
    [small]="true"
    [isValid]="formData.legalRepresentativeEmail.isValid"
    [required]="formData.legalRepresentativeEmail.required"
    [errorMessage]="formData.legalRepresentativeEmail.value | lxEmailError"
    [iconValidation]="true"
    data-qa="enrolment-juniors-legal-representative-email"
  >
    <input
      pInputText
      type="text"
      lxFormDataEmailValidity
      lxBlockSpaces
      [formData]="formData.legalRepresentativeEmail"
      [(ngModel)]="formData.legalRepresentativeEmail.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('legalRepresentativeEmail')"
      (focusout)="recalculateFormValidation('legalRepresentativeEmail')"
    />
  </lx-form-field>
  <lx-phone-number-field
    class="form-field__search-bar"
    label="Phone number"
    i18n-label
    [isValid]="formData.legalRepresentativeMobile.isValid"
    [required]="formData.legalRepresentativeMobile.required"
    [validationRequests]="validationRequests"
    (valueChange)="updatePhoneNumber($event, 'legalRepresentativeMobile')"
    data-qa="enrolment-juniors-legal-representative-phone"
  ></lx-phone-number-field>
  <lx-form-field
    label="Address (if different)"
    i18n-label
    [small]="true"
    [isValid]="formData.legalRepresentativeAddress.isValid"
    [required]="formData.legalRepresentativeAddress.required"
    [errorMessage]="formData.legalRepresentativeAddress.errorMessage"
    data-qa="enrolment-juniors-legal-representative-address-different"
  >
    <input
      pInputText
      type="text"
      lxFormDataInputValidity
      [formData]="formData.legalRepresentativeAddress"
      [(ngModel)]="formData.legalRepresentativeAddress.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('legalRepresentativeAddress')"
      (focusout)="recalculateFormValidation('legalRepresentativeAddress')"
    />
  </lx-form-field>
</ng-template>
